import React from 'react'
import { Banner } from './banner'
import { WikiIssuingSec } from './wikiIssuingSec'

export const WikiIssuing = () => {
  return (
    <>
    <Banner />
    <WikiIssuingSec />
    </>
  )
}
